import React, { Component, Fragment } from "react";
import {taxIntegrationdashboard, taxSubheaderItemCursor} from './taxToBeLinkedStyle';


class TaxIntegrationDashboard extends Component{
    render() {
        return (
            <div style={taxIntegrationdashboard}>
                <a href="integrationDashboard" className="fs-16 color-wk-primary-blue font-weight: bold active" style={taxSubheaderItemCursor}>Integration Dashboard &gt;</a> <span>Manage Tax Returns</span>
            </div>
        );
    }
}

export default TaxIntegrationDashboard;